import { lazy } from "react";
import { RouteSuspense } from "@/shared/routing/RouteSuspense";
import type { RouteObject } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useLocale } from "@seller/app/locale";

const QuickSetupPage = lazy(() => import("./pages/QuickSetupPage").then(module => ({ default: module.QuickSetupPage })));

function QuickSetupRoute() {
  const locale = useLocale();
  const { storeSlug = "" } = useParams();

  return <QuickSetupPage locale={locale} storeSlug={storeSlug} />;
}

export const onboardingRoutes: RouteObject[] = [
  {
    path: "quick-setup",
    element: <RouteSuspense><QuickSetupRoute /></RouteSuspense>,
  },
];
